module.exports = __webpack_public_path__ + "static/media/PayToActivate.c868a233.webp";